module.exports = __webpack_public_path__ + "img/club.124db50a.png";